import { render, staticRenderFns } from "./NoticeTemplateTags.vue?vue&type=template&id=f7da3148&scoped=true&"
import script from "./NoticeTemplateTags.vue?vue&type=script&lang=js&"
export * from "./NoticeTemplateTags.vue?vue&type=script&lang=js&"
import style0 from "./NoticeTemplateTags.vue?vue&type=style&index=0&id=f7da3148&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7da3148",
  null
  
)

export default component.exports